import store from "../../store";
import { SECRIP_DETAIL, SECRIP_DETAIL_ERROR, SECRIP_DETAIL_HIDE_ERROR, SECRIP_DETAIL_START_LOADER, SECRIP_DETAIL_STOP_LOADER, } from "../../interfaces/common/ScripDetail";
export default class ScripDetailActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getScripDetailData(data) {
        this.dispatch({
            type: SECRIP_DETAIL,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: SECRIP_DETAIL_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: SECRIP_DETAIL_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: SECRIP_DETAIL_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: SECRIP_DETAIL_STOP_LOADER,
        });
    }
}
